// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bea541a0","977":"e6078b3a"}[chunkId] + ".chunk.js";
};